import React, { useEffect, useMemo, useState } from "react";
import { useQueryRetrieveSpray, useQueryRetrieveSprayProducts } from "../../../services/stores";
import {  SprayExecuted, SprayProduct} from "../../../types";
import {  formatDateDDMMM, formatDateYYYYMMDD } from "../../../helpers/utils";
import LoadingInPogress from "../../../components/LoadingInProgress";
import { useProducts, usePests, useUnits } from "../../../helpers/hooks";
import "../../../assets/css/tanseeq.css";
import { SprayExecutedHeaderCard } from "./SprayExecutedHeaderCard";
import { ProductCard } from "../../../components/ProductCard";
import { ChevronDown, ChevronRight } from "react-feather";

export interface SprayExecutedCardProps {
  treatmentID: string;
  sprays: SprayExecuted[];
  onError?: (error: string) => void;
  index?: number;
  count?: number;
}

type StringNumberMapping = Record<string, number>;

export const SprayExecutedCard = ({ 
  treatmentID,
  sprays,
  onError,
  index = 0,
  count = 1
}: SprayExecutedCardProps) => {

  const {
      data: parentSpray,
      isLoading: isLoadingParentSpray,
      error: errorParentSpray } = useQueryRetrieveSpray(treatmentID);

  const {
    data: savedSprayProducts,
    isLoading: isLoadingSavedSprayProducts,
    error: errorSavedSprayProducts } = useQueryRetrieveSprayProducts(treatmentID);
          
 
  const { toUnitName } = useUnits();
    
  const startDate = sprays.map(spray => spray.startDate).reduce(function (a, b) { return a < b ? a : b; }); 
  const endDate = sprays.map(spray => spray.startDate).reduce(function (a, b) { return a > b ? a : b; }); 

  const sprayDates = (startDate === endDate) ? `${formatDateDDMMM(new Date(startDate))}` : `${formatDateDDMMM(new Date(startDate))} - ${formatDateDDMMM(new Date(endDate))}`;

  const sprayTankVolumes = useMemo(() => {
    return sprays?.reduce((acc, spray) => {
      if (!acc[spray.volumeL]) {
          acc[spray.volumeL] = 0;
    }
    acc[spray.volumeL] = acc[spray.volumeL] + 1;
      return acc;
    }, {} as Record<number, number>);
  }, [sprays]);

  const getActualQuantityDescriptions = (product: SprayProduct) => {
    const productID = product.productID;
    const quantities: StringNumberMapping = {};

    sprays.forEach(spray => {
      spray.products.forEach(product => {
        if (product.productID === productID) {
         const quantity = `${product.quantity} ${toUnitName(product.unitID)}`;
         quantities[quantity] = (quantities[quantity] || 0) + 1;
        }
      })
    })

    const actualQuantityDescriptions: string[] = [];
    Object.entries(quantities).forEach(([quantity, count]) => {
      actualQuantityDescriptions.push(`${count} x ${quantity}`);
    });

    return actualQuantityDescriptions;
  }

  const getPlannedQuantityDescription = (product: SprayProduct) => {
 
   const sprayTankCount = (parentSpray?.plannedTotalVolumeL || 0) / (parentSpray?.plannedSprayTankVolumeL || 1);
   return  `${sprayTankCount} x ${product.plannedProductQuantity} ${toUnitName(product.plannedProductQuantityUnitID)}`;

  }

  if (errorParentSpray) {
    if (onError) {
      onError(errorParentSpray.message);
    }
    return null;
  }


  return (
      <div className="product-cards" style={{ marginTop: '10px' }}>


        <React.Fragment>
        {isLoadingParentSpray && 
            <LoadingInPogress message="Chargement..." />
        }

        {parentSpray && 
          <SprayExecutedHeaderCard 
              spray={parentSpray} 
              sprayTankVolumes = {sprayTankVolumes}
              sprayDates={sprayDates}
            />
        }

        {savedSprayProducts?.map((product: SprayProduct, indexProduct: number) => (
                <ProductCard 
                key={ indexProduct} 
                product={product} 
                isRealized={true}
                actualQuantityDescriptions={getActualQuantityDescriptions(product)}
                plannedQuantityDescription={getPlannedQuantityDescription(product)}
                />

        ))}
        </React.Fragment>

      </div>
  );
};
